import axios from "axios";
import authHeader from "utils/auth-header";

const baseURL = process.env.REACT_APP_BACKEND_SERVER;

const startPayment = async (data: any) => {
  try {
    const response = await axios({
      method: "post",
      data: data,
      url: `${baseURL}/payment/process`,
      headers: authHeader(),
    });
    return response.data;
  } catch (error) {
    // Handle the error here
    console.error("startPayment - Error occurred during payment:", error);
    throw error; // You can rethrow the error or handle it as needed
  }
};

const getPaymentIntense = async (data: any) => {
  try {
    const response = await axios({
      method: "post",
      data: data,
      url: `${baseURL}/payment/intents`,
      headers: authHeader(),
    });
    return response.data;
  } catch (error) {
    // Handle the error here
    console.error(
      "getPaymentIntense - Error occurred during the payment intense:",
      error,
    );
    throw error; // You can rethrow the error or handle it as needed
  }
};

const getEventByIntense = async (intent_id: any) => {
  try {
    const response = await axios({
      method: "get",
      url: `${baseURL}/ppv-event/payment/${intent_id}`,
      headers: {
        "Content-Type": "application/json; charset=utf-8",
      },
    });
    return response.data;
  } catch (error) {
    // Handle the error here
    console.error(
      "getPaymentIntense - Error occurred during the payment intense:",
      error,
    );
    throw error; // You can rethrow the error or handle it as needed
  }
};

// Subscription: Create a Stripe subscription checkout
const createSubscription = async (data: {
  priceId: string;
  paymentMethodId: string;
}) => {
  try {
    const response = await axios({
      method: "post",
      data: data,
      url: `${baseURL}/v2/subscriptions/checkout`,
      headers: authHeader(),
    });
    return response.data;
  } catch (error) {
    console.error(
      "createSubscription - Error occurred during subscription creation:",
      error,
    );
    throw error;
  }
};

// Subscription: Cancel an active subscription
const cancelSubscription = async (data: { cancelMode: string }) => {
  try {
    const response = await axios({
      method: "post",
      data: data,
      url: `${baseURL}/v2/subscriptions/cancel`,
      headers: authHeader(),
    });
    return response.data;
  } catch (error) {
    console.error(
      "cancelSubscription - Error occurred during subscription cancellation:",
      error,
    );
    throw error;
  }
};

// Subscription: Get current user's subscription details
const getSubscription = async () => {
  try {
    const response = await axios({
      method: "get",
      url: `${baseURL}/v2/subscriptions/me`,
      headers: authHeader(),
    });
    return response.data;
  } catch (error) {
    console.error(
      "getSubscription - Error occurred during fetching subscription:",
      error,
    );
    throw error;
  }
};

// Subscription: Get subscription transactions
const getSubscriptionTransactions = async () => {
  try {
    const response = await axios({
      method: "get",
      url: `${baseURL}/v2/subscriptions/transactions`,
      headers: authHeader(),
    });
    return response.data;
  } catch (error) {
    console.error(
      "getSubscriptionTransactions - Error occurred during fetching transactions:",
      error,
    );
    throw error;
  }
};

// Subscription: Redirect to billing page
const getSubscriptionBillingPage = async () => {
  try {
    const response = await axios({
      method: "get",
      url: `${baseURL}/v2/subscriptions/billing`,
      headers: authHeader(),
    });
    return response.data;
  } catch (error) {
    console.error(
      "getSubscriptionBillingPage - Error occurred during fetching billing page:",
      error,
    );
    throw error;
  }
};

// Subscription: Get current user's subscription details
const getpurchasedSubscription =  async (id: any) => {
  try {
    const response = await axios({
      method: "get",
      url: `${baseURL}/v2/subscriptions/purchased/${id}`,
      headers: authHeader(),
    });
    return response.data;
  } catch (error) {
    console.error(
      "getpurchasedSubscription - Error occurred during fetching subscription:",
      error,
    );
    throw error;
  }
};

const PaymentService = {
  startPayment,
  getPaymentIntense,
  getEventByIntense,
  createSubscription,
  cancelSubscription,
  getSubscription,
  getSubscriptionTransactions,
  getSubscriptionBillingPage,
  getpurchasedSubscription,
};

export default PaymentService;
